import { Component } from "react";

/** Cada cuánto se permite volver a recargar por esto. */
const ESPERA_ENTRE_RECARGAS = 30_000;
const MARCA = "recarga-por-version-nueva";

/**
 * Si el error es de los de "el navegador pidió un trozo del build que ya no
 * está". Los tres navegadores lo cuentan con palabras distintas, y Chrome añade
 * el caso de recibir HTML donde esperaba un módulo.
 */
const esTrozoQueYaNoExiste = (error) =>
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|expected a javascript module script/i.test(
    String(error?.message ?? ""),
  );

/**
 * Recoge el fallo de una pestaña que se quedó con el build anterior.
 *
 * Al desplegar, los ficheros del build cambian de nombre y los de la versión
 * anterior desaparecen. Una pestaña abierta desde antes sigue pidiendo los
 * suyos; el servidor, que contesta el index.html a toda ruta que no encuentra
 * —también a un .js—, le devuelve HTML donde esperaba un módulo, y la carga
 * falla.
 *
 * Sin nadie que recoja ese error, React desmonta el árbol entero: la pantalla
 * se queda en blanco y la URL no se mueve. Eso le pasó a quien pulsó "cerrar
 * sesión" mientras salía un despliegue: se quedó en /logout, en blanco y —lo
 * peor— con la sesión todavía abierta, creyendo que había salido.
 *
 * La salida es recargar: al volver a pedir el index.html llegan los nombres
 * nuevos y lo que se pulsó funciona. Se recarga una sola vez cada medio minuto,
 * porque si el fallo no venía de un despliegue, recargar en bucle es peor que
 * enseñar el error y dejar que la persona decida.
 */
class ReloadOnStaleChunk extends Component {
  state = { fallo: null };

  static getDerivedStateFromError(error) {
    return { fallo: error };
  }

  componentDidCatch(error) {
    if (!esTrozoQueYaNoExiste(error) || this.recargadoHaceNada()) {
      return;
    }

    try {
      sessionStorage.setItem(MARCA, String(Date.now()));
    } catch {
      // Modo privado o almacenamiento bloqueado: se recarga igual, y si el
      // fallo persiste el usuario verá el aviso en vez de un bucle.
    }

    window.location.reload();
  }

  recargadoHaceNada() {
    try {
      const ultima = Number(sessionStorage.getItem(MARCA));

      return Boolean(ultima) && Date.now() - ultima < ESPERA_ENTRE_RECARGAS;
    } catch {
      return false;
    }
  }

  render() {
    if (!this.state.fallo) {
      return this.props.children;
    }

    return (
      <div className="container py-5 text-center">
        <h1 className="h4">No se pudo cargar esta pantalla</h1>
        <p className="text-muted">
          Puede que haya salido una versión nueva mientras la tenías abierta.
          Vuelve a cargar la página y prueba otra vez.
        </p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => window.location.reload()}
        >
          Recargar
        </button>
      </div>
    );
  }
}

export default ReloadOnStaleChunk;
